// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".awsui_label_1s55x_pwi13_103:not(#\\9){display:flex;align-items:center;justify-content:center;position:absolute;padding-block-end:var(--space-xxs-9rrxti, 4px);block-size:100%;inset-block-start:0;inline-size:100%;inset-inline-start:0;box-sizing:border-box;border-inline-end:1px solid transparent}.awsui_stud_1s55x_pwi13_117:not(#\\9){visibility:hidden}\n", ""]);
// Exports
module.exports = exports;
